import { css } from 'linaria';

export const hintWrapper = css`
  & > div:last-child > div {
    border-radius: var(--rounding-l) !important;
    background: var(--background-primary);
    box-shadow: var(--box-shadow-m);
    filter: none;

    & > div:first-child {
      background: var(--background-primary);
    }
  }
`;
